export const courseSessionStatuses = {
  SUCCESSFUL: 'successful',
  UNFINISHED: 'unfinished',
  UNSUCCESSFUL: 'unsuccessful',
};
